import { Spacer, Tag, TextCapitalized } from "@qivia/ui";
import { SidePanelDS } from "@qivia/ui";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { selectCompany } from "../../homeSlice";
import {
  getDepartmentsByCompanyAsync,
  selectDepartments,
  selectGetDepartmentsByCompanyStatus,
} from "../../departments/departmentsSlice";
import { ManagerRole } from "../usersAPI";
import "../../../../i18n/i18n";

export const SidePanelUserDepartments = (props: {
  managerRole: ManagerRole;
  departmentsAccess: string[] | null | undefined;
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const company = useAppSelector(selectCompany);
  const departments = useAppSelector(selectDepartments);
  const getDepartmentsStatus = useAppSelector(
    selectGetDepartmentsByCompanyStatus,
  );

  useEffect(() => {
    if (company && getDepartmentsStatus === "idle") {
      void dispatch(getDepartmentsByCompanyAsync(company.uuid));
    }
  }, [company, dispatch, getDepartmentsStatus]);

  if (props.managerRole !== "DEPARTMENT_USER") {
    return null;
  }

  if (props.departmentsAccess == null) {
    return null;
  }

  return (
    <SidePanelDS.Section horizontalSpacing={1.5} verticalSpacing={1.5}>
      <TextCapitalized>
        <StyledSectionTitle>
          {t("users.management.sidePanel.departments.title")}
        </StyledSectionTitle>
      </TextCapitalized>
      <Spacer y={1} />
      <StyledChipRow>
        {props.departmentsAccess.map((uuid) => {
          const departmentName = departments.find((d) => d.uuid === uuid)?.name;
          if (!departmentName) {
            return;
          }
          return (
            <Tag
              key={uuid}
              text={departmentName}
              textColor={colors["colors/text/darkGrey"]}
              backgroundColor={
                colors["colors/surfaces/background/background_level0"]
              }
              borderColor={colors["colors/borders/cells/cells"]}
            />
          );
        })}
      </StyledChipRow>
    </SidePanelDS.Section>
  );
};

const StyledSectionTitle = styled.div`
  ${typographies["Body/L"]}
  color: ${colors["colors/text/darkGrey"]};
`;
const StyledChipRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
`;
